<template>
  <div class="itemBankDialog">
      <el-dialog width="647px" title="请选择要考试的试卷" :visible.sync="dialogStatus" :before-close="clearDialog">
        <div class="content">
            <el-collapse v-model="activeNames">
                <el-collapse-item :title="item.sectionindexname?item.sectionindexname:'' + ' '+item.sectionname" v-for="(item, index) in bankList" :key="index" :name="index">
                    <!-- <p class="title text"></p> -->
                    <ul>
                        <li v-for="(task, taskindex) in item.taskinfolist" :key="taskindex">
                            <span class="number">{{taskindex + 1}}.</span>
                            <p class="text">{{task.taskname}}</p>
                            <span class="icon" @click="goto(task.innerid)">开始考试</span>
                        </li>
                        <!-- <li>
                            <span class="number">1.</span>
                            <p class="text">一二三四五一二三四五一二三四五一二三四五一二三四五一二三四五</p>
                            <span class="icon">开始考试</span>
                        </li>
                        <li>
                            <span class="number">1.</span>
                            <p class="text">一二三四五一二三四五一二三四五一二三四五一二三四五一二三四五</p>
                            <span class="icon">开始考试</span>
                        </li> -->
                    </ul>
                </el-collapse-item>
            </el-collapse>  
            <div>
                
            </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getQuestionbankTask} from 'api/questionbank'
export default {
  name: 'itemBankDialog',
  data () {
    return {
        dialogStatus: false,    // 弹窗状态
        activeNames: [0], // 默认展开第一个折叠面板
        bankList: [],    // 目录列表
        bankid: ''  // 列表id
    }
  },
  mounted () {},
  methods: {
      startItemBankDialog(bankid) {   // 开启考试弹窗
        this.dialogStatus = true
        // 运行接口文件
        this._itemBankApi(bankid)
      },
      clearDialog() {   // 关闭弹窗
        this.dialogStatus = false
      },
      _itemBankApi(bankid) {  // api接口文件
        this.setLoading(true)
          getQuestionbankTask({
              data: {bankid: bankid},
              success: data => {
                  this.setLoading(false)
                  this.bankid = data.data.bankid
                  this.bankList = data.data.content
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
          })
      },
      goto(taskid) {
        this.$router.push({name: 'ExaminationPaperInformation', query: {bankid: this.bankid, taskid: taskid}})
      },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.itemBankDialog {

    .el-collapse-item__header,
    .el-collapse {
        border: none;
    }
    .el-collapse-item__wrap {
        border: none;
    }
    .el-collapse-item__content {
        padding-bottom: 0;
    }
    .el-dialog__body {
        padding-top: 0;
        padding-bottom: 0;
    }
    
    .content {
        overflow-y: auto;
        height: 478px;
        font-weight: bold;
    }
    .el-collapse-item__header,
    .text {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
    }
    .el-collapse-item__header {
        font-weight: bold;

        &::before {
            content: "";
            margin-right: 8px;
            width: 0;
            height: 0;
            border-style: solid;
            border-color: #909399 transparent transparent;
            border-width: 5px;
            vertical-align: -3px;
            display: inline-block;
        }
        i {
            display: none;
        }
    }
    ul {
        li {
            display: flex;
            margin-bottom: 6px;
            padding: 10px 12px;
            background: #F8F8F8;
            cursor: pointer;

            &:hover {
                background: #F1F8FF;
                .icon {
                    display: block;
                }
            }
            .text {
                margin-left: 10px;
                width: 420px;
            }
            .number {
                width: 25px;
                color: #999999;
            }

            .icon {
                display: none;
                width: 120px;
                text-align: right;
                color: #409EFF;
                background: url('../../../../common/images/other/see_icon.png') no-repeat;
                background-position-x: 40px;
                background-position-y: center;
                background-size: 18px;
            }

        }
    }
}
</style>